export const REQUEST_TYPE_INFORMATION = 'information';
export const REQUEST_TYPE_PRICE_UPDATE = 'price_update';
export const REQUEST_TYPE_PROPOSAL = 'proposal';

/** Mirrors PriceUpdates::InheritAgreementBusinessUnit::OPEN_STATES in bidops-app. */
export const PRICE_UPDATE_INHERITING_STATES: readonly string[] = ['draft', 'open_for_questions', 'open_for_bidding'];

/**
 * request_type values surfaced as selectable options in event-type filters/dropdowns.
 * Excluding quote and purchase_request is a product decision, not something purely
 * derived from data: `BidRequest.pluck(:request_type).uniq` finding zero records of
 * either in stage/prod today supports the choice, but doesn't fully justify it — if
 * one is ever created, it stays unfilterable here with no compile-time signal, and
 * that's accepted. Add a value here, not to each consuming component individually.
 */
export const USER_FACING_REQUEST_TYPES = [
  REQUEST_TYPE_PROPOSAL,
  REQUEST_TYPE_INFORMATION,
  REQUEST_TYPE_PRICE_UPDATE,
] as const;

export type UserFacingRequestType = typeof USER_FACING_REQUEST_TYPES[number];

export const isUserFacingRequestType = (type?: string): type is UserFacingRequestType =>
  type != null && (USER_FACING_REQUEST_TYPES as readonly string[]).includes(type);

/**
 * Tooltip copy explaining why analysis is unavailable, keyed by request_type. Doubles as the
 * deny-list behind isAnalysisDisabledForRequestType.
 */
export const ANALYSIS_DISABLED_TOOLTIP_KEYS: Record<string, string> = {
  [REQUEST_TYPE_INFORMATION]: 'tooltip.bid_request.analysis_disabled_information',
  [REQUEST_TYPE_PRICE_UPDATE]: 'tooltip.bid_request.analysis_disabled_price_update',
};

const REQUEST_TYPES_WITHOUT_ANALYSIS = Object.keys(ANALYSIS_DISABLED_TOOLTIP_KEYS);

/**
 * Whether round over round analysis is unavailable for an event of this type. A deny-list, not an
 * RFP allow-list, so an unloaded or unrecognised request_type keeps its analysis.
 */
export const isAnalysisDisabledForRequestType = (requestType?: string) =>
  requestType != null && REQUEST_TYPES_WITHOUT_ANALYSIS.includes(requestType);
